var render, staticRenderFns
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./old.vue?vue&type=custom&index=0&blockType=Row"
if (typeof block0 === 'function') block0(component)
import block1 from "./old.vue?vue&type=custom&index=1&blockType=Row"
if (typeof block1 === 'function') block1(component)
import block2 from "./old.vue?vue&type=custom&index=2&blockType=Row"
if (typeof block2 === 'function') block2(component)
import block3 from "./old.vue?vue&type=custom&index=3&blockType=b-row&class=mt-2%20justify-content-center"
if (typeof block3 === 'function') block3(component)
import block4 from "./old.vue?vue&type=custom&index=4&blockType=Row"
if (typeof block4 === 'function') block4(component)
import block5 from "./old.vue?vue&type=custom&index=5&blockType=Row"
if (typeof block5 === 'function') block5(component)
import block6 from "./old.vue?vue&type=custom&index=6&blockType=Row"
if (typeof block6 === 'function') block6(component)
import block7 from "./old.vue?vue&type=custom&index=7&blockType=Row"
if (typeof block7 === 'function') block7(component)
import block8 from "./old.vue?vue&type=custom&index=8&blockType=Row&style=position%3Arelative"
if (typeof block8 === 'function') block8(component)
import block9 from "./old.vue?vue&type=custom&index=9&blockType=Row"
if (typeof block9 === 'function') block9(component)
import block10 from "./old.vue?vue&type=custom&index=10&blockType=Row"
if (typeof block10 === 'function') block10(component)
import block11 from "./old.vue?vue&type=custom&index=11&blockType=Row"
if (typeof block11 === 'function') block11(component)
import block12 from "./old.vue?vue&type=custom&index=12&blockType=Row"
if (typeof block12 === 'function') block12(component)
import block13 from "./old.vue?vue&type=custom&index=13&blockType=Row"
if (typeof block13 === 'function') block13(component)
import block14 from "./old.vue?vue&type=custom&index=14&blockType=Row"
if (typeof block14 === 'function') block14(component)
import block15 from "./old.vue?vue&type=custom&index=15&blockType=Row"
if (typeof block15 === 'function') block15(component)
import block16 from "./old.vue?vue&type=custom&index=16&blockType=Row"
if (typeof block16 === 'function') block16(component)
import block17 from "./old.vue?vue&type=custom&index=17&blockType=Row"
if (typeof block17 === 'function') block17(component)
import block18 from "./old.vue?vue&type=custom&index=18&blockType=Row"
if (typeof block18 === 'function') block18(component)
import block19 from "./old.vue?vue&type=custom&index=19&blockType=Row"
if (typeof block19 === 'function') block19(component)
import block20 from "./old.vue?vue&type=custom&index=20&blockType=Row"
if (typeof block20 === 'function') block20(component)
import block21 from "./old.vue?vue&type=custom&index=21&blockType=Row"
if (typeof block21 === 'function') block21(component)
import block22 from "./old.vue?vue&type=custom&index=22&blockType=Row"
if (typeof block22 === 'function') block22(component)
import block23 from "./old.vue?vue&type=custom&index=23&blockType=Row"
if (typeof block23 === 'function') block23(component)

export default component.exports